import { render, staticRenderFns } from "./I2FormVueSelect.vue?vue&type=template&id=d0bd2f76"
import script from "./I2FormVueSelect.vue?vue&type=script&lang=js"
export * from "./I2FormVueSelect.vue?vue&type=script&lang=js"
import style0 from "./I2FormVueSelect.vue?vue&type=style&index=0&id=d0bd2f76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports